import React, { createContext, useContext, ReactNode } from "react";
import { useSeason, Season } from "@/hooks/useSeason";

interface SeasonContextType {
  season: Season;
  isSummer: boolean;
  isWinter: boolean;
}

const SeasonContext = createContext<SeasonContextType | undefined>(undefined);

interface SeasonProviderProps {
  children: ReactNode;
}

/**
 * Provider de contexte saisonnier
 * Utilisé uniquement pour la section About
 */
export const SeasonProvider: React.FC<SeasonProviderProps> = ({ children }) => {
  const season = useSeason();

  const value: SeasonContextType = {
    season,
    isSummer: season === "summer",
    isWinter: season === "winter",
  };

  return (
    <SeasonContext.Provider value={value}>
      {children}
    </SeasonContext.Provider>
  );
};

/**
 * Hook pour accéder au contexte saisonnier
 */
export const useSeasonContext = (): SeasonContextType => {
  const context = useContext(SeasonContext);
  if (context === undefined) {
    throw new Error("useSeasonContext must be used within a SeasonProvider");
  }
  return context;
};
